<footer class="footer">
  <div class="footer__navigation--desktop">
    <app-grid-container class="footer__navigation-container">
      @if (navigation().length) {
        <app-grid-row>
          @for (column of navigation(); track $index) {
            <app-grid-column [md]="3">
              @if (column.title) {
                <p class="footer__navigation-title">{{ column.title }}</p>
              }

              <nav aria-label="Navigation list desktop">
                <ul class="footer__navigation-list">
                  @for (link of column.links; track $index) {
                    <li class="footer__navigation-list-item">
                      <a
                        [attr.aria-label]="link.label"
                        [href]="link.href"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {{ link.label }}
                      </a>
                    </li>
                  }
                </ul>
              </nav>
            </app-grid-column>
          }
        </app-grid-row>
      }
    </app-grid-container>
  </div>

  <div class="footer__navigation--mobile">
    <app-grid-container>
      <app-grid-row>
        <app-grid-column>
          <app-accordion [panels]="panels()">
            <ng-template
              #accordionPanelHeaderTemplate
              let-expanded="expanded"
              let-panel="panel"
            >
              <span class="footer__accordion-header">
                <span class="footer__accordion-title">
                  {{ panel.title }}
                </span>

                <app-icon
                  [name]="expanded ? 'circle-minus' : 'circle-plus'"
                  [size]="'lg'"
                  class="footer__accordion-icon"
                />
              </span>
            </ng-template>

            <ng-template
              #accordionPanelContentTemplate
              let-expanded="expanded"
              let-panel="panel"
            >
              <nav aria-label="Navigation list mobile">
                <ul class="footer__navigation-list">
                  @for (link of panel.links; track $index) {
                    <li class="footer__navigation-list-item">
                      <a
                        [href]="link.href"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {{ link.label }}
                      </a>
                    </li>
                  }
                </ul>
              </nav>
            </ng-template>
          </app-accordion>
        </app-grid-column>
      </app-grid-row>
    </app-grid-container>
  </div>

  <app-grid-container>
    @if (socialLinksWithIcon) {
      <app-grid-row>
        <app-grid-column>
          <ul class="footer__social-list">
            @for (socialLink of socialLinksWithIcon; track $index) {
              <li>
                <a
                  [href]="socialLink.href"
                  attr.aria-label="view {{
                    socialLink.icon
                  }} profile (opens in a new window)"
                  target="_blank"
                >
                  <app-icon
                    [family]="'brands'"
                    [name]="socialLink.icon"
                    [size]="'lg'"
                    class="footer__social-list-item-icon"
                  />
                </a>
              </li>
            }
          </ul>
        </app-grid-column>
      </app-grid-row>
    }

    @if (legalContent()) {
      <app-grid-row class="footer__legal">
        <app-grid-column>
          <p>{{ legalContent() }}</p>
        </app-grid-column>
      </app-grid-row>
    }

    <app-grid-row class="footer__copyright">
      <app-grid-column>
        <p>&copy; {{ copyrightYear }} {{ copyrightOwner() }}</p>
      </app-grid-column>
    </app-grid-row>

    <app-grid-row class="footer__cookie-management">
      <app-grid-column>
        <button
          (click)="openCookieManagement()"
          class="footer__cookie-management-button"
          type="button"
        >
          Cookie Management
        </button>
      </app-grid-column>
    </app-grid-row>
  </app-grid-container>
</footer>
